// Libs
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Suspense } from 'react';
import { ToastContainer } from 'react-toastify';
// Components, Layouts, Pages
import { ProtectedRoute } from './components/common';
import { MainLayout } from './layouts';
import { LoadingPage } from './pages/student';
// Others
import { authRoute } from '~/utils/routes/auth';
import { RoleEnum } from './utils/enum/common';
import { publicRoutes } from './utils/routes';
import { studentRoute, privateStudentRoutes } from './utils/routes/student';
import { adminRoute, privateAdminRoutes } from './utils/routes/admin';
import { privateTeacherRoutes, teacherRoute } from './utils/routes/teacher';
import { StorageEnum } from './utils/enum/base';

type Props = {};

const App = (props: Props) => {
  const RootRedirect = () => {
    const accessToken = localStorage.getItem(StorageEnum.ACCESS_TOKEN);
    const role = localStorage.getItem(StorageEnum.ROLE);

    if (accessToken && role) {
      switch (role) {
        case RoleEnum.STUDENT:
          return <Navigate to={studentRoute.base} />;
        case RoleEnum.ADMIN:
          return <Navigate to={adminRoute.base} />;
        case RoleEnum.TEACHER:
          return <Navigate to={teacherRoute.base} />;
        default:
          return <Navigate to={authRoute.base} />;
      }
    }

    return <Navigate to={authRoute.base} />;
  };

  return (
    <BrowserRouter>
      <ToastContainer />
      <Suspense fallback={<LoadingPage />}>
        <Routes>
          <Route path='/' element={<RootRedirect />}></Route>

          <Route path='/'>
            {publicRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route key={index} path={route.path} element={<Page />}>
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>

          <Route element={<ProtectedRoute roles={[RoleEnum.STUDENT, RoleEnum.TEACHER, RoleEnum.ADMIN]} />}>
            <Route path={studentRoute.base} element={<MainLayout />}>
              {privateStudentRoutes.map((route, index) => {
                const Page = route.component || '';
                return (
                  <Route key={index} path={route.path} element={<Page />}>
                    {route.children &&
                      route.children.length > 0 &&
                      route.children.map((childRoute, index) => {
                        const ChildComponent = childRoute.component;
                        return (
                          <Route
                            key={index}
                            path={childRoute.path}
                            index={childRoute.index ?? false}
                            element={<ChildComponent />}
                          />
                        );
                      })}
                  </Route>
                );
              })}
            </Route>
          </Route>

          <Route element={<ProtectedRoute roles={[RoleEnum.ADMIN]} />}>
            <Route path={adminRoute.base} element={<MainLayout />}>
              {privateAdminRoutes.map((route, index) => {
                const Page = route.component || '';
                return (
                  <Route key={index} path={route.path} element={<Page />}>
                    {route.children &&
                      route.children.length > 0 &&
                      route.children.map((childRoute, index) => {
                        const ChildComponent = childRoute.component;
                        return (
                          <Route
                            key={index}
                            path={childRoute.path}
                            index={childRoute.index ?? false}
                            element={<ChildComponent />}
                          />
                        );
                      })}
                  </Route>
                );
              })}
            </Route>
          </Route>

          <Route element={<ProtectedRoute roles={[RoleEnum.TEACHER]} />}>
            <Route path={teacherRoute.base} element={<MainLayout />}>
              {privateTeacherRoutes.map((route, index) => {
                const Page = route.component || '';
                return (
                  <Route key={index} path={route.path} element={<Page />}>
                    {route.children &&
                      route.children.length > 0 &&
                      route.children.map((childRoute, index) => {
                        const ChildComponent = childRoute.component;
                        return (
                          <Route
                            key={index}
                            path={childRoute.path}
                            index={childRoute.index ?? false}
                            element={<ChildComponent />}
                          />
                        );
                      })}
                  </Route>
                );
              })}
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
